import { FC } from 'react';

import { AuthFormDisplayState } from 'src/authentication/templates/AuthForm/AuthForm.types';
import { MICROCOPY } from 'src/data/microcopy/microcopyDictionary';
import { BadgeIllustration } from 'src/general/components/BadgeIllustration/BadgeIllustration';
import { BADGE } from 'src/general/components/BadgeIllustration/BadgeIllustration.type';
import { getMicrocopy } from 'src/stores/microcopyStore';

import classes from './AuthFormFooter.module.scss';

const footerContentConfig: { [key in AuthFormDisplayState]: { icon: BADGE; copy: MICROCOPY }[] } = {
  default: [
    { icon: BADGE.DELIVERY, copy: MICROCOPY.AUTHENTICATION_SIGNIN_FOOTER_NAVBAR_1 },
    { icon: BADGE.THIRD_PARTY, copy: MICROCOPY.AUTHENTICATION_SIGNIN_FOOTER_NAVBAR_2 },
    { icon: BADGE.REVIEWS, copy: MICROCOPY.AUTHENTICATION_SIGNIN_FOOTER_NAVBAR_3 },
  ],
  watchlist: [
    { icon: BADGE.REVIEWS, copy: MICROCOPY.AUTHENTICATION_SIGNIN_FOOTER_WATCHLIST_1 },
    { icon: BADGE.GOT_YOUR_BACK, copy: MICROCOPY.AUTHENTICATION_SIGNIN_FOOTER_WATCHLIST_2 },
    { icon: BADGE.DELIVERY, copy: MICROCOPY.AUTHENTICATION_SIGNIN_FOOTER_WATCHLIST_3 },
  ],
  carAlerts: [
    { icon: BADGE.SUCCESS_1, copy: MICROCOPY.AUTHENTICATION_SIGNIN_FOOTER_CAR_ALERTS_1 },
    { icon: BADGE.SAVE_TIME, copy: MICROCOPY.AUTHENTICATION_SIGNIN_FOOTER_CAR_ALERTS_2 },
    { icon: BADGE.FAVORITE, copy: MICROCOPY.AUTHENTICATION_SIGNIN_FOOTER_CAR_ALERTS_3 },
  ],
  personalisedQuote: [
    { icon: BADGE.COMPLETE, copy: MICROCOPY.AUTHENTICATION_SIGNIN_FOOTER_PERSONALISED_QUOTE_1 },
    { icon: BADGE.SAVE_TIME, copy: MICROCOPY.AUTHENTICATION_SIGNIN_FOOTER_PERSONALISED_QUOTE_2 },
    { icon: BADGE.FAVORITE, copy: MICROCOPY.AUTHENTICATION_SIGNIN_FOOTER_PERSONALISED_QUOTE_3 },
  ],
  checkout: [
    { icon: BADGE.GOT_YOUR_BACK, copy: MICROCOPY.AUTHENTICATION_SIGNIN_FOOTER_PDP_CTA_1 },
    { icon: BADGE.DELIVERY, copy: MICROCOPY.AUTHENTICATION_SIGNIN_FOOTER_PDP_CTA_2 },
    { icon: BADGE.FINANCE_ONLINE, copy: MICROCOPY.AUTHENTICATION_SIGNIN_FOOTER_PDP_CTA_3 },
  ],
  carmatch: [
    { icon: BADGE.DELIVERY, copy: MICROCOPY.AUTHENTICATION_SIGNIN_FOOTER_CARMATCH_1 },
    { icon: BADGE.THIRD_PARTY, copy: MICROCOPY.AUTHENTICATION_SIGNIN_FOOTER_CARMATCH_2 },
    { icon: BADGE.REVIEWS, copy: MICROCOPY.AUTHENTICATION_SIGNIN_FOOTER_CARMATCH_3 },
  ],
};

interface Props {
  displayState: AuthFormDisplayState;
}

export const AuthFormFooter: FC<Props> = ({ displayState }) => {
  const copies = footerContentConfig[displayState];

  return (
    <div className={classes.root}>
      <ul className={classes.list}>
        {copies.map(({ icon, copy }) => (
          <li key={icon} className={classes.item}>
            <div className={classes.itemImgWrapper}>
              <BadgeIllustration icon={icon} background="none" shape="square" className={classes.itemImg} />
            </div>
            <div className={classes.itemLabel}>{getMicrocopy(copy, true)}</div>
          </li>
        ))}
      </ul>
    </div>
  );
};
